import React from 'react';

const SupportContent = () => {
  return (
    <div className="prose dark:prose-invert max-w-none">
      <h2 className="text-2xl font-bold mb-4">Support</h2>
      <p className="mb-4">
        If you need support, please contact us at <a href="mailto:contact@padam.ai" className="text-blue-500 hover:underline">contact@padam.ai</a>.
      </p>
      <p className="mb-4">
        Our support team is available to assist you with any questions or issues you may encounter.
        We strive to respond to all inquiries within 24-48 business hours.
      </p>
      <p className="mb-4">
        For urgent matters, please include "Urgent" in the subject line of your email.
      </p>
    </div>
  );
};

export default SupportContent;
